export const Logo = ({ width, color }: { width?: number; color?: 'white' }) => {
  return (
    <div
      style={{
        width,
      }}
    >
      <img src={color === 'white' ? `/images/logo_white.png` : `/images/logo.png`} style={{ width: '100%' }} />
    </div>
  )
}
